export const Header = () => {
  return (
    <header className='px-[20px] pt-[16px] pb-[30px] md:py-[30px] md:px-[32px]'>
      <a href='/'>
        <img src='./img/logo_rttg.svg' alt='RTTG' className='w-[69px]' />
      </a>
      <h1 className='mt-[36px] text-center text-[2.4rem] md:mt-[20px] md:text-[2.8rem]'>
        タイムシェアカレンダー
      </h1>
      <p className='mt-[5px] text-center text-[1.4rem] text-[#B4A570]'>Time Share Calendar</p>
    </header>
  );
};
